import { useEffect, useState } from "react";
import DonutChart from "../../../components/atomic/DonutChart";
import { useUtilityStates } from "../useStates";
import { calculateLoanDetails, calculateOfferTotal, calculatePercentage } from "./OfferCalculatorFunctions";
import { BreakDownColors } from "../interface";
import { formatNumberIntl } from "../../../shared/utils/DateUtil";

const OfferBreakdown = () => {
  const { offerCalculation,existingOffers,sidebar } = useUtilityStates((state) => state);
  let offerDetails = existingOffers[sidebar.offerIndex || 0];
  const [offerBreakDown, setOfferBreakdown] = useState({
    emiAmount: 0,
    principalAmount: 0,
    interestPayable: 0,
  });
  const [segments, setSegments]: any = useState([]);

  useEffect(() => {
    const { loanAmount, loanTenure, rateOfInterset, tenureType } = offerCalculation;
  
    // Early return if any required value is missing
    // if (!loanAmount || !loanTenure || !rateOfInterset) return;

  
    const loanDetails = calculateLoanDetails(
      loanAmount,
      rateOfInterset,
      loanTenure,
      tenureType
    );
  
    const segments = [
      {
        value: Number(loanAmount),
        label: "Principal Amount",
        color: BreakDownColors.PRINCIPAL_AMOUNT,
      },
      {
        value: Number(loanDetails.interestPayable),
        label: "Interest Payable",
        color: BreakDownColors.INTERSET_PAYABLE,
      },
    ];
  
    setSegments(segments);
    setOfferBreakdown(loanDetails);
  }, [offerCalculation]);

  return (
    <div>
      <div className="space-y-6">
        <div className=" text-2xl font-medium leading-8 text-left font-inter">
          Breakdown
        </div>
        <div className=" text-sm text-gray-500">Your Amortization details</div>
        <div className="flex pt-10 gap-14">
          <DonutChart
            size={150}
            strokeWidth={20}
            segments={segments}
          />
          <div>
            <div className=" text-sm text-gray-500">Your EMI Amount</div>
            <div>
              <div className="text-[#343F59] font-bold text-2xl p-2 pl-0 pb-6 ">
                {formatNumberIntl(offerBreakDown.emiAmount ? offerBreakDown.emiAmount : 0)}
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex gap-4">
                {/* vertical line */}
                <div
                  style={{
                    border: "2px solid" + BreakDownColors.PRINCIPAL_AMOUNT,
                  }}
                  className="h-12  border-l-4 "
                ></div>
                <div>
                  <div className=" text-sm text-gray-500">Principal Amount</div>
                  <div>{offerBreakDown.principalAmount ? formatNumberIntl(offerBreakDown.principalAmount) :0}</div>
                </div>
              </div>
              <div className="flex gap-4">
                {/* vertical line */}
                <div
                  style={{
                    border: "2px solid" + BreakDownColors.INTERSET_PAYABLE,
                  }}
                  className="h-12  border-l-4 "
                ></div>
                <div>
                  <div className=" text-sm text-gray-500">Interest payable</div>
                  <div>{offerBreakDown.interestPayable ? formatNumberIntl(offerBreakDown.interestPayable) : 0}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-4 items-center">
          {" "}
          <div className="text-sm text-gray-500">
            {" "}
            Total Payment (Principal + Interest - Processing Fees){" "}
          </div>{" "}
          <div className="text-[#343F59] flex  font-bold text-l  ">
            
            {calculateOfferTotal(offerBreakDown.principalAmount,offerBreakDown.interestPayable,offerCalculation.loanAmount,offerDetails.processingFee)}
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export default OfferBreakdown;
